module.exports = __webpack_public_path__ + "static/img/2@2x.d39c089.png";


//////////////////
// WEBPACK FOOTER
// ./static/2@2x.png
// module id = adIb
// module chunks = 1